import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ActivateIQIcon from '../../img/activateiq_icon.png';

const AtlasUnavailableMessage = ({ variant, className }) => {
	const isWidget = variant === 'widget';
	return (
		<div className={cx('atlas-unavailable-message', { 'atlas-unavailable-message--widget': isWidget }, className)}>
			<div className='app-loading-page__brand'>
				<img src={ActivateIQIcon} className='app-loading-page__icon' alt='' />
				<span className='app-loading-page__brand-name'>Activate IQ</span>
			</div>
			<p className='atlas-unavailable-message__text'>Atlas is currently being updated. Please try again later.</p>
			<p className='atlas-unavailable-message__subtext'>If the problem persists, please contact support.</p>
		</div>
	);
};

AtlasUnavailableMessage.propTypes = {
	variant: PropTypes.oneOf(['page', 'widget']),
	className: PropTypes.string
};

AtlasUnavailableMessage.defaultProps = {
	variant: 'page'
};

export default AtlasUnavailableMessage;
